/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { sort } from '@ember/object/computed';
import ExtApiKeyModel from 'cio/models/ext-api-key';
import WhitelistedIpAddressModel from 'cio/models/whitelisted-ip';

interface AppKeysTableComponentArgs {
  apiKeys: ExtApiKeyModel[];
  whitelistedIpAddresses: WhitelistedIpAddressModel[];
  readOnly: boolean;
  environmentId?: string;
  onCreate: (key: ExtApiKeyModel) => unknown;
  onUpdate: (key: ExtApiKeyModel) => unknown;
  onDelete: (key: ExtApiKeyModel) => unknown;
}

export default class AppKeysTableComponent extends Component<AppKeysTableComponentArgs> {
  apiKeySortDefinition = ['isNew:desc'];
  @sort('args.apiKeys', 'apiKeySortDefinition') sortedApiKeys!: ExtApiKeyModel[];
}
